import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Coordinates client-side teardown when logging out: notifies subscribers to unsubscribe
 * from user-scoped HTTP, and signals the error interceptor to ignore 403 during teardown.
 */
@Injectable({
    providedIn: 'root',
})
export class AuthSessionTransitionService {
    private readonly teardown$ = new Subject<void>();
    private logoutInProgress = false;

    /** Emits when logout begins; use with takeUntil to cancel in-flight HTTP tied to the session. */
    get sessionTeardown$(): Observable<void> {
        return this.teardown$.asObservable();
    }

    beginLogoutSequence(): void {
        this.logoutInProgress = true;
        this.teardown$.next();
    }

    endLogoutSequence(): void {
        this.logoutInProgress = false;
    }

    isLogoutInProgress(): boolean {
        return this.logoutInProgress;
    }
}
